import { render, staticRenderFns } from "./ConversationItem.vue?vue&type=template&id=6f9d6be7&scoped=true&"
import script from "./ConversationItem.vue?vue&type=script&lang=js&"
export * from "./ConversationItem.vue?vue&type=script&lang=js&"
import style0 from "./ConversationItem.vue?vue&type=style&index=0&id=6f9d6be7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9d6be7",
  null
  
)

export default component.exports